import axios from 'axios';
import {useDispatch} from 'react-redux';
import {showSheet} from '../actions/SheetActions';

const useCheckVpn = () => {
  const dispatch = useDispatch();

  const checkVpn = async ({onClose}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const value = await axios.get('https://echo.zeero.ir');
        const response = value?.data ?? '';
        const startIndex = response.indexOf('X-Country-Code');
        const xCountryMessage = response?.slice(startIndex, startIndex + 21);
        const isIran = xCountryMessage.includes('IR');

        if (!isIran && xCountryMessage) {
          resolve('');
          dispatch(
            showSheet({
              sheetId: 'tripMessage',
              sheetProps: {
                type: 'vpn',
                onClose: onClose ?? undefined,
              },
            }),
          );
        } else {
          reject('');
        }
      } catch (err) {
        resolve('');
      }
    });
  };

  return {
    checkVpn,
  };
};

export default useCheckVpn;
